module.exports = __webpack_public_path__ + "static/media/customer-io.2383551d.svg";